import { all } from 'redux-saga/effects';
import { watchContact } from './contact';
import { legalEntitiesSaga } from './entities';

function* rootSaga() {
  yield all([watchContact(), legalEntitiesSaga()]);
}

export default rootSaga;
